import localforage from 'myStore'
import actions from './actions'
import NativeInterface from 'services/native-interface/om-native-client'
import { isOfficeChatWebview } from 'libs/userAgent'
import { AppSettingsState } from './types'

const STORED_SETTINGS = async (
  storedSettings: Partial<AppSettingsState>,
): Promise<Partial<AppSettingsState>> => {
  const settings: Partial<AppSettingsState> = {}
  // Object.keys(storedSettings).forEach((key) => { // forEach는 async로 하면 순서 보장이 안됨. 동시 실행 개념.
  const keys = Object.keys(storedSettings)
  for (const key of keys) {
    const item = await localforage.getItem(`app.appsettings.${key}`)
    settings[key] = item != null ? (item as AppSettingsState[typeof key]) : storedSettings[key]
  }
  return settings
}

function isOfficenextMessenger(): boolean {
  const userAgent = window.navigator.userAgent
  let isOfficenextMessenger = false
  if (
    isOfficeChatWebview(userAgent) ||
    userAgent.indexOf('Electron') > -1 ||
    userAgent.indexOf('popup-calendar') > -1
  ) {
    isOfficenextMessenger = true
  }
  return isOfficenextMessenger
}

function isDesktopSession(): boolean {
  return NativeInterface.isAvailable()
}

const initialState: AppSettingsState = {
  ...(await STORED_SETTINGS({
    authProvider: 'landing',
    logo: 'OfficeMail Web Access',
    viewMode: null,
    isSidebarOpen: false,
    isMobileMenuOpen: false,
    isMenuCollapsed: true,
    menuLayoutType: 'left',
    routerAnimation: 'zoom-fadein',
    menuColor: 'white',
    leftMenuWidth: 256,
    isContentMaxWidth: true,
    isOfficenextMessenger: isOfficenextMessenger(),
    isDesktopSession: isDesktopSession(),
  })),
}

interface AppSettingsAction {
  type: string
  payload?: Partial<AppSettingsState>
}

export default function appSettingsReducer(
  state: AppSettingsState = initialState,
  action: AppSettingsAction,
): AppSettingsState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
